"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PROTECTED_TYPE = exports.COLORED_GROUP_CLASS_NAME = exports.COLORED_CLASS_NAME = exports.Color = void 0;

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));
/**
 * Allowed colors of tag
 * @enum {String}
 */


var Color = {
  LIGHT_STEEL_BLUE: 'light-steel-blue',
  PLUM: 'plum',
  MISTY_ROSE: 'misty-rose',
  LIGHT_GOLDENROD_YELLOW: 'light-goldenrod-yellow',
  PALE_GREEN: 'pale-green',
  SILVER: 'silver',
  GRAY: 'gray'
};
/**
 * @const
 * @type {String}
 */

exports.Color = Color;
var COLORED_CLASS_NAME = 'wind-tag-colored';
/**
 * @const
 * @type {String}
 */

exports.COLORED_CLASS_NAME = COLORED_CLASS_NAME;
var COLORED_GROUP_CLASS_NAME = "".concat(COLORED_CLASS_NAME, "-group");
/**
 * @const
 * @type {Symbol}
 */

exports.COLORED_GROUP_CLASS_NAME = COLORED_GROUP_CLASS_NAME;
var PROTECTED_TYPE = (0, _symbol["default"])('TAG_PROTECTED_TYPE');
exports.PROTECTED_TYPE = PROTECTED_TYPE;